import React, { useState, useEffect, useRef } from 'react';

import { /*reqGET,*/ repo_img_link, content_language, translate, compose_link_nl } from '../../../../Utils';

//import * as Hosts from "../../../../Hosts";

import parse from 'html-react-parser';

import Loader from '../../../../loader';
import "./HomeFloatingContent_02.css"

const HomeFloatingContent = (props) => {

	const [, set_dados] = useState(null)
	const content_list = useRef([])
	const dados_config = useRef([])
	const dados_component = useRef([])
	const count = useRef(0)

    //const [content_title, set_content_title] = useState('')
    //const [content_subtitle, set_content_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);
    
    const [color_primary, set_color_primary] = useState('');

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(dados_component.current = props.dados_component)

            if(props.component_order !== undefined) {
                set_dados(count.current = props.component_order)
            }

            set_color_primary(dados_config.current.info.theme.info.color.primary)

            for (let el of dados_config.current.content[0].components) {

                if(el.id === dados_component.current.id && el.info.tag === 'floating') {
                    //set_content_title(translate(el.info.title, lang))
                    //set_content_subtitle(translate(el.info.subtitle, lang))

                    set_dados(content_list.current.push(el))
                    setLoading(false)
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, [props, lang])

    return (
        isloading ?
            <Loader />
		:
            <table cellSpacing="0" cellPadding="0" align="center" className="es-content" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important' }}>
                <tbody>
                    <tr style={{ borderCollapse: 'collapse' }} >
                        <td align="center" style={{ padding: '0', margin: '0' }}>
                            <table cellSpacing="0" cellPadding="0" bgcolor="#ffffff" align="center" className="es-content-body" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#FFFFFF', width: '600px' }}>
                                <tbody>   
                                    {
                                    content_list.current !== undefined && content_list.current !== null && content_list.current.length > 0 ?
                                        content_list.current.map((v, k) => {
                                            return (
                                                <tr key={k} style={{ borderCollapse: 'collapse' }} >
                                                    <td align="left" bgcolor="#ffffff" style={{ padding: '0', margin: '0', paddingTop: '15px', paddingBottom: '15px', paddingRight: '10px', backgroundColor: '#ffffff' }} >
                                                        <table style={{ width: '590px' }} cellPadding="0" cellSpacing="0">
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '590px' }} valign="top">
                                                                        <table cellSpacing="0" cellPadding="0" align="right" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                            <tbody>
                                                                                <tr style={{ borderCollapse: 'collapse' }} >
                                                                                    <td align="left" className="es-m-p20b" style={{ padding: '0',  paddingRight: '30px', paddingLeft: '30px', margin: '0', width: '590px' }} >
                                                                                        <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                                            <tbody>
                                                                                                <tr style={{ borderCollapse: 'collapse' }} >
                                                                                                    <td align="left" style={{ margin: '0', paddingTop: '15px', paddingRight: '5px', paddingBottom: '5px', paddingLeft: '5px' }} >
                                                                                                        <h3 className="es-m-txt-c" style={{ margin: '0', marginTop: (count.current > 0 ? '50px' : '0'), fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '18px', fontStyle: 'normal', fontWeight: 'bold', lineHeight: '21.6px', color: '#000000' }} >
                                                                                                            {translate(v.info.title, 'pt')}
                                                                                                        </h3>
                                                                                                        <h3 className="es-m-txt-c" style={{ margin: '0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '18px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '21.6px', color: '#000000' }} >
                                                                                                            {translate(v.info.subtitle, 'pt')}
                                                                                                        </h3>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                <tr style={{ borderCollapse: 'collapse' }} >
                                                                                                    <td align="left" style={{ padding: '0', margin: '0', paddingTop: '10px' }} >
                                                                                                        <div className="product-description es-m-txt-c" style={{ margin: '0', msoLineHeightRule: 'exactly', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", lineHeight: '21px', letterSpacing: '0', color: '#333333', fontSize: '14px' }} >
                                                                                                            {parse(translate(v.info.text, 'pt'))}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                <tr style={{ borderCollapse: 'collapse' }} >
                                                                                                    <td align="center" style={{ padding: '0', margin: '0' }} >
                                                                                                        <div className="col-12 text-center" style={{marginTop: '15px'}}>
                                                                                                            <a className="" style={{fontSize: '14px', fontWeight: '700', backgroundColor: '#FFFFFF', border: '2px solid ' + color_primary, color: color_primary, whiteSpace: 'normal', paddingBottom: '6px', paddingLeft: '18px', paddingRight: '18px', paddingTop: '8px', textDecoration: 'none', display: 'inline-block'}} href={compose_link_nl(dados_config.current.info.uniqid, 'fl', count.current, '*')} >{translate(v.info.btn_label, 'pt')}</a>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    :
                                        null
                                    }
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
    )
};
export default HomeFloatingContent;